import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
        <span className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 border border-background-200 text-accent-400 text-4xl mb-6">
          <i className="ri-movie-2-line" />
        </span>
        <p className="font-heading text-5xl md:text-6xl font-black text-primary-500">404</p>
        <h1 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm text-foreground-600 max-w-md leading-relaxed">
          你访问的页面不存在或已被移动。可以返回首页，或到剧集列表继续浏览《美国式禁忌2》的内容。
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-600 hover:bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 hover:border-accent-500 text-foreground-800 hover:text-accent-300 text-sm whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-list-check-2" />
            剧集列表
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}